import i18n from 'i18next';
/** Localize display text only; identifiers, inputs and API values stay canonical. */
export function displayDigits(value: string | number, locale = i18n.resolvedLanguage ?? i18n.language): string {
  const text = String(value).replace(/٫/g, '.');
  if (!/^fa(?:-|$)/i.test(locale ?? '')) return text;
  const localized = text.replace(/[0-9٠-٩]/g, digit => {
    const code = digit.charCodeAt(0);
    return '۰۱۲۳۴۵۶۷۸۹'[code >= 0x660 ? code - 0x660 : Number(digit)];
  });
  // Isolate signed numbers so RTL text cannot move the sign to their right.
  return localized.replace(/[-−+][۰-۹]+(?:[.,٫٬/][۰-۹]+)*/g, number => `\u2066${number}\u2069`);
}
